import { NavigationData } from "@ubisolutions/core";

export const ADMIN_NAVIGATION: NavigationData = {
    settings: {
        prefix: "administration-ubi",
    },
    routes: [
        {
            key: "routing.administration-ubi.dashboard._title",
            route: "dashboard",
            icon: "dashboard",
        },
        {
            key: "routing.administration-ubi.infrastructure._title",
            icon: "graph_4",
            children: [
                {
                    key: "routing.administration-ubi.infrastructure.sites._title",
                    route: "infrastructure/sites",
                    icon: "business",
                    allPermissions: ["Site"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.managers._title",
                    route: "infrastructure/managers",
                    icon: "storage",
                    allPermissions: ["Manager"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.stations._title",
                    route: "infrastructure/stations",
                    icon: "router",
                    allPermissions: ["Station"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.tags._title",
                    route: "infrastructure/tags",
                    icon: "nfc",
                    allPermissions: ["Tag"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.driver._title",
                    route: "infrastructure/driver",
                    icon: "extension",
                    allPermissions: ["Driver"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.config-tags._title",
                    route: "infrastructure/update-tags",
                    icon: "rule_settings",
                    allPermissions: ["TagConfig"],
                },
            ],
        },
        {
            key: "routing.administration-ubi.security._title",
            icon: "security",
            children: [
                {
                    key: "routing.administration-ubi.security.clients._title",
                    route: "security/clients",
                    icon: "diversity_2",
                    allPermissions: ["Client"],
                },

                {
                    key: "routing.administration-ubi.security.users._title",
                    route: "security/users",
                    icon: "supervisor_account",
                    allPermissions: ["User"],
                },
                {
                    key: "routing.administration-ubi.security.roles._title",
                    route: "security/roles",
                    icon: "engineering",
                    allPermissions: ["Role"],
                },
            ],
        },
        {
            key: "routing.administration-ubi.plan-management._title",
            icon: "assignment",
            anyPermission: ["Plan", "QuotaPolicy", "QuotaOverride", "PlanAssign", "PlanConfigDefault", "TenantConfig"],
            children: [
                {
                    key: "routing.administration-ubi.plan-management.plans._title",
                    route: "plan-management/plans",
                    icon: "list_alt",
                    allPermissions: ["Plan"],
                },
                {
                    key: "routing.administration-ubi.plan-management.quota-policies._title",
                    route: "plan-management/quota-policies",
                    icon: "speed",
                    allPermissions: ["QuotaPolicy"],
                },
                {
                    key: "routing.administration-ubi.plan-management.quota-overrides._title",
                    route: "plan-management/quota-overrides",
                    icon: "swap_vert",
                    allPermissions: ["QuotaOverride"],
                },
                {
                    key: "routing.administration-ubi.plan-management.plan-assigns._title",
                    route: "plan-management/plan-assigns",
                    icon: "link",
                    allPermissions: ["PlanAssign"],
                },
                {
                    key: "routing.administration-ubi.plan-management.plan-config-defaults._title",
                    route: "plan-management/plan-config-defaults",
                    icon: "settings_suggest",
                    allPermissions: ["PlanConfigDefault"],
                },
                {
                    key: "routing.administration-ubi.plan-management.tenant-configs._title",
                    route: "plan-management/tenant-configs",
                    icon: "tune",
                    allPermissions: ["TenantConfig"],
                },
            ],
        },
        {
            key: "routing.administration.imports._title",
            icon: "publish",
            route: "imports",
            anyPermission: ["ImportHistory"],
        },
    ],
};
